import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const checkDuplicateClaim = createProvider(api.checkDuplicateClaim).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Check duplicate claim aborted');
  } else {
    console.error('Check duplicate claim was failed:', error);
  }
  throw error;
});
